module.exports = __webpack_public_path__ + "d4d576dbf3afb3d66025c12cd3d2c916.png";